import { AbstractCommand } from 'src/models/command';

class MailSpamByAggregateIdCommand extends AbstractCommand {
	readonly name = 'IFS_Desktop_Command_Command_Desktop_Actions_SpamTheSelectedAggregateIds';

	public constructor(aggregateId: string, processId: string) {
		super();
		this.processId = processId;
		this.parameters = {
			aggregateIds: [aggregateId],
		};
	}
}

export { MailSpamByAggregateIdCommand };
